class Structure {
    deviceType = "structure";
    code = "";
    structureType = "Telhado ..."
    description = "";
    manufacturer = "";
    unit = "pacote(s)";
    railConnector = {};
    maxLengthBetweenSupports = 0;
    endRailLength = 0;
    lengthBetweenModules = 0;
    rails = [

        //     {id:12344, deviceId:"xxx",device:{code:"sxdxc", description:"xxxx"}},
        //  {id:999, deviceId:"aaa",device:{code:"sxdxc", description:"xxxx"}} 

    ]; //Always two for each structure
    accessories = [
        //  {id:133444, deviceId:"abcd", device:{code:"sxdxc", description:"xxxx"}, quantity:1, formula:0 }, //Formulas 0-Numero de modulos, 1-Termnal intermediario,2- Terminal final,3- Fileira                           
        //   {id:15455 , deviceId:"xxsd",device:{code:"sxdxc", description:"xxxx"}, quantity:1, formula:1 } //Formulas 0-Numero de modulos, 1-Termnal intermediario,2- Terminal final,3- Fileira                           

    ]
    supports = [
        //{id:112345, deviceId:"1",device:{code:"sxdxc", description:"xxxx"}, quantity:1},
        //{id:922299,deviceId:"2",device:{code:"sxdxc", description:"xxxx"}, quantity:0}
    ]
    railConnectors=[];


    product = {
        price: 0,
        cost: 0,
        // taxes:0,
        sellerId: "", //Now its a string
        available: true, //editted by the user
        unit: "pacote(s)",
        quantity: 0

    };

    constructor() {
    };



    calc() {

    }

    //calular inversor
}




export default Structure;
